import { ResendErrorsEnum } from '@shared/verification/enum';

export const resendErrorAlerts: {[key: string]: {heading: string; body: string}} = {
  [ResendErrorsEnum.alreadyVerified]: {
    heading: 'Error: ',
    body: 'Account already verified. Please log in.',
  },
  [ResendErrorsEnum.noUser]: {
    heading: 'Error: ',
    body: 'Unknown username. Check your username and try logging in again.',
  },
  [ResendErrorsEnum.unknown]: {
    heading: 'Unknown error: ',
    body: 'Please try sending verification code again.',
  },
  [ResendErrorsEnum.unknownUsername]: {
    heading: 'Error: ',
    body: 'Unknown username. Check your username and try logging in again.',
  },
  [ResendErrorsEnum.rateLimited]: {
    heading: 'Error: ',
    body: 'We just resent a verification email. Please wait before retrying.',
  },
};
